import { Component } from '@angular/core'
import { TranslatePipe } from '@spartacus/core'
import { AnonymousConsentOpenDialogComponent } from '@spartacus/storefront'

@Component({
  selector: 'eb-anonymous-consent-open-dialog',
  templateUrl: './eb-anonymous-consent-open-dialog.component.html',
  styleUrls: ['./eb-anonymous-consent-open-dialog.component.scss'],
  imports: [TranslatePipe]
})
export class EbAnonymousConsentOpenDialogComponent extends AnonymousConsentOpenDialogComponent {}
